export interface Role {
  id: string;
  name: string;
}

export interface PublishedRoles {
  id: string;
  roleName: string;
  roleId: string
}

export interface Device {
  id: string;
  name: string;
  os: string;
  agentVersion: string;
  ipAddresses: string[];
  tags: string[];
  profile: string;
  operatingMode: 'auditing' | 'enforcing';
  status: 'online' | 'offline';
  management: {
    publish: boolean;
    roles: string[];
  };
  recording: boolean;
  hasSettings: boolean;
}

export interface ResourceTypeData {
  name: string;
  value: number;
  color: string;
}

export interface EventsTimelineData {
  date: string;
  events: number;
}

export interface RecentActivityData {
  id: string;
  event: string;
  from: string;
  details: string;
  time: string;
  description: string;
  computer: string;
  user: string;
  path: string;
}

export interface RecentLoginData {
  id: string;
  computerName: string;
  message: string;
  status: 'Valid' | 'Invalid';
  timestamp: string;
  updatedAt: string;
}

export interface TopUserData {
  id: string;
  user: string;
  count: number;
  percent: number;
}

export interface TopComputerData {
  id: string;
  name: string;
  count: number;
  percent: number;
}

export interface TopResourceData {
  id: string;
  resource: string;
  count: number;
  percent: number;
}

export interface AlertData {
  id: string;
  level: string;
  user: string;
  computerId?: string;
  computerName: string;
  processName: string;
  message: string;
  type: string;
  updatedAt: string;
  tags?: string[];
  sigmaResults: any[],
  computerUserEmail: string,
  resourceName: string,
  time: string,
  Process: string,
  eventjson: any
}

export interface AlertLevelData {
  level: string;
  count: number;
  color: string;
}

export interface AlertsTimelineData {
  date: string;
  alerts: number;

}

export interface RiskyAlertData {
  id: string;
  name: string;
  description: string;
  level: string;
  count: number;
  percentage: string;
}

export interface RiskyUserData {
  id: string;
  username: string;
  alertCount: number;
  percentage: string;
}

export interface RiskyMachineData {
  id: string;
  computerName: string;
  alertCount: number;
  percentage: string;
}

export interface LolBinTimelineData {
  date: string;
  activity: number;
}

export interface LolBinActivityData {
  id: string;
  timeAgo: string;
  processPath: string;
  pid: string;
  launchedApp: string;
  launchedPid: string;
  user: string;
  computerName: string;
}

export interface TopLolBinData {
  id: string;
  executable: string;
  percentage: number;
}

export interface TopLolBinUserData {
  id: string;
  username: string;
  percentage: number;
}

export interface TopLolBinComputerData {
  id: string;
  computerName: string;
  percentage: number;
}

export interface AuditLogData {
  id: string;
  time: string;
  computerUser: string;
  computerName: string;
  type: string;
  resourceName: string;
  action: string;
}

export interface RecordingData {
  id: string;
  user: string;
  startDate: string;
  endDate: string;
  duration: string;
  remoteHost: string;
}


export interface PublishComponentProps {
  entityName: string;
  entityType?: string;
  availableRoles: Role[];
  publishedRoles: string[];
  onPublish: (selectedRoles: string[]) => void;
  disabled?: boolean;
  buttonVariant?: "default" | "outline" | "secondary" | "ghost" | "destructive";
  buttonSize?: "default" | "sm" | "lg" | "icon";
}

export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded bg-gray-200 dark:bg-gray-700 ${className}`} />;
}